import PropTypes from 'prop-types';
import BaseSelectorReadonlyToInput from "../Select/BaseSelectorReadonlyToInput";

class DashboardTemplatesSelector extends BaseSelectorReadonlyToInput {

  constructor(props) {
    super(props);
    this.state = {
      ...this.state,
      title: 'Tipos de Template',
      label: 'name',
      items: [
        {id: 'STOCK_LEVEL', name: 'Nível de Estoque '},
      ]
    };
  }

}

DashboardTemplatesSelector.propTypes = {
  required: PropTypes.bool,
  setValue: PropTypes.func,
  defaultValue: PropTypes.string,
  readonly: PropTypes.bool,
  onChange: PropTypes.func,
};

export default DashboardTemplatesSelector;



// WEBPACK FOOTER //
// ./src/component/DashboardTemplates/DashboardTemplatesSelector.js